// extracted by css-extract-rspack-plugin
export default {"container":"dhJQ7eP72A4x2PyK","header":"VWZmcte9eAyyy1Wp","title":"iCCQOGv_4IsdjhAa"};